import React, { useEffect, useState } from "react";
import { PencilIcon, PlusIcon as PlusIcon } from "@heroicons/react/24/solid";
import { TrashIcon as TrashIconMini } from "@heroicons/react/20/solid";
import { useQuery, gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import _ from "lodash";
import insurancePlans from "../../../gql/insurancePlans";
import ptpa from "../../../gql/ptpa";
import beneficiary from "../../../gql/beneficiary";
import AddBeneficiaryIplanModal from "./AddBeneficiaryIplanModal";
import ConformationModal from "../../../components/ConformationModal";
import { Button, IconButton } from "@mui/material";
import { Formik, FieldArray, Field, useFormik } from "formik";
import Modal from "react-modal";
import * as Yup from "yup";
import "../styles/BeneficiaryList.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../shared/CustomFilterInput";
// yyy
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

function InsurancePlans({
  item,
  personalDetailValues,
  personalDetailsAreValid,
  patientId,
  setFieldValue,
  chiReqRecord,
  setIsFormReset,
  isFormReset,
  formik,
  systemType,
}) {
  const { t, i18n } = useTranslation();
  const [reloadKey, setReloadKey] = useState(0);
  const [payers, setPayers] = useState([]);
  const coverageTypes = [
    { id: "EHCPOL", name: "Extended Healthcare" },
    { id: "PUBLICPOL", name: "Public Healthcare" },
  ];

  const subscriberRelation = [
    { id: null, name: t("Please Select") },
    { id: "child", name: t("Child") },
    { id: "parent", name: t("Parent") },
    { id: "spouse", name: t("Spouse") },
    { id: "common", name: t("Common") },
    { id: "other", name: t("Other") },
    { id: "self", name: t("Self") },
    { id: "injuired", name: t("Injuired") },
  ];

  const classType = [
    { id: null, name: t("Please Select") },
    { id: "group", name: t("Group") },
    { id: "subgroup", name: t("SubGroup") },
    { id: "plan", name: t("Plan") },
    { id: "subplan", name: t("SubPlan") },
    { id: "class", name: t("Class") },
    { id: "subclass", name: t("SubClass") },
    { id: "sequence", name: t("Sequence") },
    { id: "rxbin", name: t("RX BIN") },
    { id: "rxpcn", name: t("RX PCN") },
    { id: "rxid", name: t("RX Id") },
    { id: "rxgroup", name: t("RX Group") },
  ];

  function convertKeysToSnakeCase(obj) {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map((item) => convertKeysToSnakeCase(item));
    }

    const snakeCaseObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const snakeCaseKey = key.replace(
          /[A-Z]/g,
          (match) => `_${match.toLowerCase()}`,
        );
        snakeCaseObj[snakeCaseKey] = convertKeysToSnakeCase(obj[key]);
      }
    }

    return snakeCaseObj;
  }

  const addDataa = (values) => {
    setShowAddIplanModal(false);
    let data = values;
    if (item?.id) {
      let tempData = values;
      tempData["patientId"] = patientId;
      tempData["id"] = item?.id;
      updateInsurancePlan({
        variables: { input: convertKeysToSnakeCase(tempData) },
      });

      console.log("item?.id :: ", convertKeysToSnakeCase(tempData));
    } else if (item) {
      let tempData = [...personalDetailValues.insurance_plans];
      tempData[currentIndex] = data;
      setFieldValue("insurance_plans", convertKeysToSnakeCase(tempData));
      setInsurances(convertKeysToSnakeCase(tempData));

      console.log("item :: ", convertKeysToSnakeCase(tempData));
    } else {
      let tempData = [...personalDetailValues.insurance_plans];
      tempData.push(data);
      setFieldValue("insurance_plans", convertKeysToSnakeCase(tempData));
      setInsurances(convertKeysToSnakeCase(tempData));

      console.log("else :: ", convertKeysToSnakeCase(tempData));
    }
  };

  const getDesiredObject = (desiredValue) => {
    const result = _.find(payers, {
      id: desiredValue,
    });
    return result;
  };

  const getPayerId = (item) => {
    if (item?.payer) {
      return item?.payer?.id;
    } else if (item?.payer_id) {
      let payerObj = getDesiredObject(item?.payer_id);
      return payerObj?.id;
    } else {
      return null;
    }
  };

  useEffect(() => {
    setReloadKey(reloadKey + 1);
  }, [item]);

  useEffect(() => {
    if (chiReqRecord) {
      if (systemType === "5") {
        const insuranceArray = chiReqRecord.Insurance.map(async (insurance) => {
          let payerId = "";

          return {
            member_card_id: "",
            policy_number: insurance.PolicyNumber || "",
            expiry_date: "",
            is_primary: true,
            payer_id: payerId,
            relation_with_subscriber: "self",
            patient_share: "0.00",
            max_limit: 0,
            network: "",
            issue_date: "",
            sponsor_no: "",
            policy_class_type: "",
            policy_holder: "",
            insurance_type: "",
            insurance_status: "",
            insurance_duration: "",
            policy_class_name: "",
            coverage_type: "Extended Healthcare",
            policy_class_id: "",
          };
        });

        // Wait for all promises to resolve
        Promise.all(insuranceArray).then((resolvedInsuranceArray) => {
          setFieldValue("insurance_plans", resolvedInsuranceArray);
        });
      } else {
        const insuranceArray = chiReqRecord.Insurance.map(async (insurance) => {
          let payerId = "";

          if (payers?.length > 0) {
            for (const tpa of payers) {
              const payer = await tpa?.payers?.find((payer) => {
                const nameENWithoutAsterisk = payer?.name_en.replace(/\*/g, "");
                const nameARWithoutAsterisk = payer?.name_ar.replace(/\*/g, "");
                return (
                  _.includes(
                    nameARWithoutAsterisk,
                    insurance?.InsuranceCompanyAR || insurance?.ArabicICName,
                  ) ||
                  _.includes(
                    nameENWithoutAsterisk,
                    insurance?.InsuranceCompanyEN ||
                      insurance?.InsuranceCompany,
                  )
                );
              });

              if (payer) {
                payerId = payer.id || "";
                break;
              }
            }
          }

          return {
            member_card_id: insurance.BeneficiaryNumber || "",
            policy_number: insurance.PolicyNumber || "",
            expiry_date: insurance.ExpiryDate || "",
            is_primary: true,
            payer_id: payerId,
            relation_with_subscriber: "self",
            // coverage_type: "Extended Healthcare",
            patient_share: insurance.DeductibleRate || "0.00",
            max_limit: +insurance.MaxLimit || 0,
            network: insurance.NetworkID || "",
            issue_date: insurance.IssueDate || insurance.ISSUEDATE || "",
            sponsor_no: insurance.SponsorNumber || "",
            policy_class_type: "plan",
            policy_holder: insurance.PolicyHolder || "",
            insurance_type: "",
            insurance_status: "",
            insurance_duration: "",
            policy_class_name: "",
            coverage_type: "Extended Healthcare",
            policy_class_id: insurance.ClassName || "",
          };
        });

        Promise.all(insuranceArray).then((resolvedInsuranceArray) => {
          setFieldValue("insurance_plans", resolvedInsuranceArray);
        });
      }
    }
  }, [chiReqRecord]);
  // getPayerId(item)

  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [showDelAlert, setShowDelAlert] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [iPlanData, setIPlanData] = useState(1);
  const [currentInsurance, setCurrentInsurance] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [showAddIplanModal, setShowAddIplanModal] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const [createInsurancePlan, { data, loading, error }] = useMutation(
    insurancePlans.CREATE_INSURANCE_PLAN,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  useEffect(() => {
    if (personalDetailValues.insurance_plans) {
      setInsurances(personalDetailValues.insurance_plans);
    }
  }, [personalDetailValues.insurance_plans]);

  const [
    updateInsurancePlan,
    {
      data: updateIplanData,
      loading: updateIplanLoading,
      error: updateIplanError,
    },
  ] = useMutation(insurancePlans.UPDATE_INSURANCE_PLAN, {
    update(proxy, result) {
      onSuccessfulRequestResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulRequestResponse = (data) => {
    if (data.insurancePlansRegistration) {
      toast.success("Successfully Added Insurance Plans!");

      let arr = [...insurances];
      arr.push(data?.insurancePlansRegistration?.Data[0]);
      setInsurances(arr);
      setFieldValue("insurancePlans", arr);
    } else if (data.insurancePlanUpdate) {
      toast.success("Successfully Updated Insurance Plans!");
      console.log(
        "data?.insurancePlanUpdate?.Data[0] :: ",
        data?.insurancePlanUpdate?.Data,
      );
      let arr = [...insurances];
      arr[currentIndex] = data?.insurancePlanUpdate?.Data[0];
      setInsurances(arr);
      setFieldValue("insurancePlans", arr);
    } else if (data.deleteInsurancePlan) {
      toast.success("Successfully Delete Insurance Plan!");
      // deleteFromLocalState();
    } else {
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error}`);
  };

  const onSuccessfulCreatePatientRequestResponse = (data) => {
    if (data.patientRegistration) {
      toast.success("Successfully Added!");
      if (!personalDetailValues.is_new_born) {
        let tempData = iPlanData;
        tempData["patientId"] = data.patientRegistration.Data._id;
        console.log("temp", tempData);
        createInsurancePlan({ variables: { input: tempData } });
      } else {
        navigate(-1);
      }
    } else {
    }
  };

  const onResponseCreatePatientError = (error) => {
    toast.error(`${error.message}`);
  };

  const [
    createPatient,
    { data: patientData, loading: patientLoading, error: patientError },
  ] = useMutation(beneficiary.CREATE_PATIENT, {
    update(proxy, result) {
      onSuccessfulCreatePatientRequestResponse(result.data);
    },
    onError(error) {
      onResponseCreatePatientError(error.graphQLErrors[0]);
    },
  });

  const [editBeneficiary, { updatedData, updatedLoading, updatedError }] =
    useMutation(beneficiary.UPDATE_BENEFICIARY, {
      update(proxy, result) {
        onSuccessfulEditResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    });

  const onSuccessfulEditResponse = (data) => {
    if (data.updatePatient) {
      toast.success("Successfully updated! ");
      if (!personalDetailValues.is_new_born) {
        let tempData = {
          memberCardId: iPlanData.memberCardId,
          policyNumber: iPlanData.policyNumber,
          expiryDate: iPlanData.expiryDate,
          maxLimit: iPlanData.maxLimit,
          payerNphiesId: iPlanData.payerNphiesId,
        };

        tempData["patientId"] = data.updatePatient.Data._id;
        tempData["_id"] = item?.plansData?.length && item.plansData[0]._id;

        updateInsurancePlan({ variables: { input: tempData } });
      } else {
        navigate(-1);
      }
    } else {
    }
  };

  // const {
  //   loading: payersLoading,
  //   error: payersError,
  //   data: payersData,
  //   refetch,
  // } = useQuery(ptpa.GET_ALL_PAYERS, {
  //   variables: { limit: 100, page: 1 },
  // });

  const getPayerName = (payerId) => {
    if (payerId && payers?.length > 0) {
      for (const payer of payers) {
        const result = _.find(payer.payers, { id: payerId });

        if (result) {
          return result.name_en;
        }
      }
    }

    return "";
  };

  function findPayerById(payerId) {
    if (payerId && payers?.length > 0) {
      for (const tpa of payers) {
        for (const payer of tpa.payers) {
          if (payer.id === payerId) {
            return payer;
          }
        }
      }
    }
    return null;
  }

  const [deletingIndex, setDeletingIndex] = useState(null);

  const handleOpenDelAlert = (index) => {
    setShowDelAlert(true);
    setDeletingIndex(index);
  };

  const onClickDelete = () => {
    const plans = formik?.values?.insurance_plans;

    // Create a new array without the item at deletingIndex
    const updatedInsurancePlans = plans.filter(
      (_, index) => index !== deletingIndex,
    );

    console.log("updated plans", updatedInsurancePlans, deletingIndex);

    formik?.setFieldValue("insurance_plans", updatedInsurancePlans);
    setShowDelAlert(false);
    setDeletingIndex(null);
  };

  React.useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem("payersData"));

    if (payersData && payersData.length > 0) {
      setPayers(payersData);
    } else {
      navigate("/dashboard");
    }
  }, []);

  return (
    <>
      <div>
        <div className="">
          {formik?.values?.insurance_plans?.map((el, index) => (
            <div
              key={index}
              className="insurance-plans !mb-2 !mt-1 !p-2 insurance-plann"
            >
              <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-1.5">
                <div className="col-span-2">
                  <CustomFilterInput
                    label={t("Payer*")}
                    name={`insurance_plans[${index}].payer_id`}
                    isSelect={true}
                    placeholder={t("Select Payer")}
                    value={formik?.values.insurance_plans?.[index]?.payer_id}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                    error={formik?.errors.insurance_plans?.[index]?.payer_id}
                    touched={formik?.touched.insurance_plans?.[index]?.payer_id}
                    renderOptions={() => (
                      <>
                        {payers?.map((category) => (
                          <optgroup
                            label={`${category?.name_en} (${category?.license_id})`}
                            key={category.id}
                          >
                            {category?.payers?.map((ins, i) => (
                              <option key={i} value={ins?.id}>
                                {ins?.name_en} ({ins?.license_id})
                              </option>
                            ))}
                          </optgroup>
                        ))}
                      </>
                    )}
                  />
                </div>
                <CustomFilterInput
                  label={t("Issue Date*")}
                  name={`insurance_plans[${index}].issue_date`}
                  type="date"
                  value={formik?.values.insurance_plans?.[index]?.issue_date}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={formik?.errors.insurance_plans?.[index]?.issue_date}
                  touched={formik?.touched.insurance_plans?.[index]?.issue_date}
                />
                <CustomFilterInput
                  label={t("Expiry Date*")}
                  name={`insurance_plans[${index}].expiry_date`}
                  type="date"
                  value={formik?.values.insurance_plans?.[index]?.expiry_date}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={formik?.errors.insurance_plans?.[index]?.expiry_date}
                  touched={
                    formik?.touched.insurance_plans?.[index]?.expiry_date
                  }
                />
                <CustomFilterInput
                  label={t("Member Card ID*")}
                  name={`insurance_plans[${index}].member_card_id`}
                  placeholder={t("Member Card ID")}
                  value={
                    formik?.values.insurance_plans?.[index]?.member_card_id
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.member_card_id
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.member_card_id
                  }
                />
                <CustomFilterInput
                  label={t("Policy Number*")}
                  name={`insurance_plans[${index}].policy_number`}
                  placeholder={t("Policy Number")}
                  value={formik?.values.insurance_plans?.[index]?.policy_number}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={formik?.errors.insurance_plans?.[index]?.policy_number}
                  touched={
                    formik?.touched.insurance_plans?.[index]?.policy_number
                  }
                />
                <CustomFilterInput
                  label={t("Relation with Subscriber")}
                  name={`insurance_plans[${index}].relation_with_subscriber`}
                  isSelect={true}
                  options={subscriberRelation}
                  placeholder={t("Please Select")}
                  value={
                    formik?.values.insurance_plans?.[index]
                      ?.relation_with_subscriber
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                />
                <CustomFilterInput
                  label={t("Patient Share")}
                  name={`insurance_plans[${index}].patient_share`}
                  placeholder="0.00"
                  value={formik?.values.insurance_plans?.[index]?.patient_share}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                />
                <CustomFilterInput
                  label={t("Max Limit*")}
                  name={`insurance_plans[${index}].max_limit`}
                  placeholder="0"
                  value={formik?.values.insurance_plans?.[index]?.max_limit}
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={formik?.errors.insurance_plans?.[index]?.max_limit}
                  touched={formik?.touched.insurance_plans?.[index]?.max_limit}
                />
                <CustomFilterInput
                  label={t("Sponsor No")}
                  name={`insurance_plans[${index}].sponsor_no`}
                  placeholder={t("Sponsor No")}
                  value={formik?.values.insurance_plans?.[index]?.sponsor_no}
                  onChange={formik?.handleChange}
                />
                <div className="col-span-2">
                  <CustomFilterInput
                    label={t("Policy Holder*")}
                    name={`insurance_plans[${index}].policy_holder`}
                    placeholder={t("Policy Holder")}
                    value={
                      formik?.values.insurance_plans?.[index]?.policy_holder
                    }
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                    error={
                      formik?.errors.insurance_plans?.[index]?.policy_holder
                    }
                    touched={
                      formik?.touched.insurance_plans?.[index]?.policy_holder
                    }
                  />
                </div>
                <CustomFilterInput
                  label={t("Insurance Status")}
                  name={`insurance_plans[${index}].insurance_status`}
                  placeholder={t("Insurance Status")}
                  value={
                    formik?.values.insurance_plans?.[index]?.insurance_status
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.insurance_status
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.insurance_status
                  }
                />
                <CustomFilterInput
                  label={t("Insurance Duration")}
                  name={`insurance_plans[${index}].insurance_duration`}
                  placeholder={t("Insurance Duration")}
                  value={
                    formik?.values.insurance_plans?.[index]?.insurance_duration
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.insurance_duration
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.insurance_duration
                  }
                />
                <CustomFilterInput
                  label={t("Insurance Type")}
                  name={`insurance_plans[${index}].insurance_type`}
                  placeholder={t("Insurance Type")}
                  value={
                    formik?.values.insurance_plans?.[index]?.insurance_type
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.insurance_type
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.insurance_type
                  }
                />
                <CustomFilterInput
                  label={t("Network")}
                  name={`insurance_plans[${index}].network`}
                  placeholder={t("Network")}
                  value={formik?.values.insurance_plans?.[index]?.network}
                  onChange={formik?.handleChange}
                />
              </div>
              <h1 className="font-bold text-lg mt-2">{t("Coverage Class")}</h1>
              <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-1.5">
                <CustomFilterInput
                  label={t("Class ID*")}
                  name={`insurance_plans[${index}].policy_class_id`}
                  placeholder={t("Class ID")}
                  value={
                    formik?.values?.insurance_plans?.[index]?.policy_class_id
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.policy_class_id
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.policy_class_id
                  }
                />
                <CustomFilterInput
                  label={t("Class Name")}
                  name={`insurance_plans[${index}].policy_class_name`}
                  placeholder={t("Class Name")}
                  value={
                    formik?.values.insurance_plans?.[index]?.policy_class_name
                  }
                  onChange={formik?.handleChange}
                />
                <CustomFilterInput
                  label={t("Class Type*")}
                  name={`insurance_plans[${index}].policy_class_type`}
                  isSelect={true}
                  options={classType}
                  placeholder={t("Please Select")}
                  value={
                    formik?.values.insurance_plans?.[index]?.policy_class_type
                  }
                  onChange={formik?.handleChange}
                  onBlur={formik?.handleBlur}
                  error={
                    formik?.errors.insurance_plans?.[index]?.policy_class_type
                  }
                  touched={
                    formik?.touched.insurance_plans?.[index]?.policy_class_type
                  }
                />
                <div className="flex justify-end items-end col-span-2 md:col-span-3">
                  <IconButton
                    color="error"
                    aria-label="delete"
                    size="small"
                    onClick={() => handleOpenDelAlert(index)}
                  >
                    <DeleteIcon fontSize="small" sx={{ fontSize: "16px" }} />
                  </IconButton>
                </div>
              </div>

              {findPayerById(formik?.values?.insurance_plans[index]?.payer_id)
                ?.flag ? (
                <div className="text-red-500 text-sm flex gap-2 mt-2">
                  <span className="font-semibold">{t("NOTE")}:</span>
                  <span>
                    {
                      findPayerById(
                        formik?.values?.insurance_plans[index]?.payer_id,
                      )?.name_en
                    }{" "}
                    {t(
                      "is cooperating with multiple TPAs. Kindly crosscheck from the list",
                    )}
                  </span>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>

      <ConformationModal
        open={showDelAlert}
        setOpen={() => setShowDelAlert(false)}
        onDelete={onClickDelete}
      />
    </>
  );
}

export default InsurancePlans;
